<template>
  <div class="mt-1">
    <div class="row mb-3">
      <div class="col-12">
        <h2 class="bp-color">CLIENT PREFERENCES</h2>
        <p class="mb-4">Please use the following page to make changes to the preferences in regards to your Genius Money portal.</p>
      </div>

      <div class="col-12">
        <ValidationObserver ref="savePreferences" slim>
          <form role="form" @submit.prevent="save_preferences">
            <div class="row">
              <div class="col-12">
                <b-card header="Timesheet Preferences" header-tag="h4" body-class="mb-3 pb-0 record_card_body">

                  <div class="row">
                    <div class="col-lg-8">
                      <p class="font-weight-bold" style="line-height: 40px">How contractors are sorted on the timesheet submission and historic pages</p>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group">
                        <ValidationProvider rules="required" v-slot="{errors, classes}" name="Number of Sites" tag="div">
                          <label class="form-label" for="sort_workers_by">Sort Contractors By</label>
                          <multiselect v-model="sort_workers_by" id="sort_workers_by" name="sort_workers_by" placeholder="" :options="ms_opts.sort_workers_by"
                                       class="requiredField" :class="classes"></multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </div>
                    </div>

                  </div>
                  <div class="row mt-3 mb-2">
                    <div class="col-md-6 offset-md-6 ">
                      <button type="submit" class="btn orcaBtn w-100" :disabled="saving">
                        <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>SAVING PREFERENCES ...</span>
                        <span v-else>SAVE PREFERENCES</span>
                      </button>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: "c_timesheet_preferences",
  components: {
    Multiselect,
    BootstrapToggle
  },
  data() {
    return {
      saving: false,
      pref_id: null,
      company_user_id: '',
      sort_workers_by: null,
      ms_opts: {
        sort_workers_by: ['First Name', 'Surname']
      },
    }
  },
  created() {
    axios.get(this.crmApiPath + 'timesheet_preferences/contact/' + this.$store.state.auth.me.contact_id).then(prefs => {
      this.pref_id = prefs.data.id;
      this.company_user_id = prefs.data.company_id;
      this.sort_workers_by = prefs.data.sort_workers_by;
    })
  },
  methods: {
    save_preferences() {
      this.$refs.savePreferences.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.savePreferences);
        }
        else {
          this.saving = true;

          axios.patch(this.crmApiPath + 'timesheet_preferences/' + this.pref_id, {
            sort_workers_by: this.sort_workers_by
          }).then(() => {
            this.$snotify.success('Preferences Saved');
            this.$nextTick(() => this.saving = false);
          })
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.clientProfile {
  .container {
    max-width: 100% !important;
  }

  .card {
    position:         relative;
    display:          flex;
    flex-direction:   column;
    min-width:        0;
    word-wrap:        break-word;
    background-color: #ffffff;
    background-clip:  border-box;
    border:           2px solid rgba(230, 0, 126, 1);
    border-radius:    0.25rem;
    box-shadow:       none;
    opacity:          1;
    padding:          1.25rem 0 0;
    margin-bottom:    1.5rem;
  }

  .cardTitle {
    position:       absolute;
    top:            -16px;
    font-weight:    bold;
    background:     #ffffff;
    padding-left:   5px;
    padding-right:  5px;
    text-transform: uppercase;
  }
}

</style>
